
import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { 
  RotateCcw, 
  RotateCw, 
  Copy, 
  Trash2, 
  FlipHorizontal, 
  FlipVertical, 
  SendToBack, 
  BringToFront,
  Maximize
} from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useFullscreen } from "@/contexts/FullscreenContext";

interface ToolbarProps {
  editorRef: React.MutableRefObject<any>;
}

const Toolbar = ({ editorRef }: ToolbarProps) => {
  const { toast } = useToast();
  const { toggleFullscreen } = useFullscreen();

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.rotateSelected(-5)}
        title="Roteer Links"
      >
        <RotateCcw className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.rotateSelected(5)}
        title="Roteer Rechts"
      >
        <RotateCw className="h-4 w-4" />
      </Button>
      <div className="h-5 w-px bg-border" />
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.duplicateSelected()}
        title="Dupliceer"
      >
        <Copy className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.deleteSelected()}
        title="Verwijder"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
      <div className="h-5 w-px bg-border" />
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.flipSelectedHorizontal()}
        title="Spiegel Horizontaal"
      >
        <FlipHorizontal className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.flipSelectedVertical()}
        title="Spiegel Verticaal"
      >
        <FlipVertical className="h-4 w-4" />
      </Button>
      <div className="h-5 w-px bg-border" />
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.sendSelectedToBack()}
        title="Naar Achteren"
      >
        <SendToBack className="h-4 w-4" />
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => editorRef.current?.bringSelectedToFront()}
        title="Naar Voren"
      >
        <BringToFront className="h-4 w-4" />
      </Button>
      <div className="h-5 w-px bg-border" />
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8"
        onClick={() => {
          // Enter fullscreen mode and fit view to see entire map
          toggleFullscreen();
          
          // Also fit the viewport to show all content
          if (editorRef.current?.fitViewport) {
            editorRef.current.fitViewport();
          }
          
          toast({
            title: "Volledige kaart",
            description: "Druk op ESC of de knop rechtsboven om terug te gaan",
          });
        }}
        title="Volledige Kaart"
      >
        <Maximize className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default Toolbar;
